import React from 'react';
export function ContactForm({
  id = 'contact-form'
}: {
  id?: string;
}) {
  return <div id={id} style={{
    width: '100%'
  }} data-id="element-27">
      <iframe id="JotFormIFrame-260705964650360" title="DealersChoice Digital Marketing LP Form" allowTransparency={true} allow="geolocation; microphone; camera; fullscreen; payment" src="https://form.jotform.com/260705964650360" frameBorder="0" style={{
      minWidth: '100%',
      maxWidth: '100%',
      height: '800px',
      border: 'none',
      display: 'block'
    }} scrolling="no" data-id="element-28" />
    </div>;
}